import 'highcharts/modules/accessibility';

import * as Highcharts from 'highcharts';

import HighchartsReact from 'highcharts-react-official';
import React from 'react';

export interface HgChartProps {
  chartData: any;
  className?: string;
}
export default function HgChart({ chartData, className }: HgChartProps) {
  return (
    <div className={className}>
      <HighchartsReact highcharts={Highcharts} options={chartData} />
    </div>
  );
}
